import { DeviceModel, IDevice } from './device.model';

export interface ISession {
  sessionId: string;
  deviceId: string;
  uidUser: string;
  appVersion: string;
  appBuild: string;
  deviceDescription: string;
  deviceName: string;
  manufacturer: string;
  brand: string;
  model: string;
  osVersion: string;
  osRelease: string;
  ip: string;
  country: string;
  state: string;
  city: string;
  latitude: number | null;
  longitude: number | null;
  active: boolean;
  closedAt: string | null;
  uidClosedBy: string | null;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  device?: IDevice | null;
}

export class SessionModel {
  sessionId: string;
  deviceId: string;
  uidUser: string;
  appVersion: string;
  appBuild: string;
  deviceDescription: string;
  deviceName: string;
  manufacturer: string;
  brand: string;
  model: string;
  osVersion: string;
  osRelease: string;
  ip: string;
  country: string;
  state: string;
  city: string;
  latitude: number | null;
  longitude: number | null;
  active: boolean;
  closedAt: Date | null;
  uidClosedBy: string | null;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;
  device: DeviceModel | null;

  constructor(data: ISession) {
    this.sessionId = data.sessionId;
    this.deviceId = data.deviceId;
    this.uidUser = data.uidUser;
    this.appVersion = data.appVersion;
    this.appBuild = data.appBuild;
    this.deviceDescription = data.deviceDescription;
    this.deviceName = data.deviceName;
    this.manufacturer = data.manufacturer;
    this.brand = data.brand;
    this.model = data.model;
    this.osVersion = data.osVersion;
    this.osRelease = data.osRelease;
    this.ip = data.ip;
    this.country = data.country;
    this.state = data.state;
    this.city = data.city;
    this.latitude = data.latitude ?? null;
    this.longitude = data.longitude ?? null;
    this.active = data.active;
    this.closedAt = data.closedAt ? new Date(data.closedAt) : null;
    this.uidClosedBy = data.uidClosedBy ?? null;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.device = data.device ? new DeviceModel(data.device) : null;
  }

  get location(): string {
    return [this.city, this.state, this.country].filter((part) => !!part).join(', ');
  }
}
